<template>
	<div id="daycount" class="d-inline">
		<template v-if="days > 0 && hours > 0">
			<span> {{ days | two_digits }} Hari </span> : <span> {{hours | two_digits}} Jam</span>
			<!-- : <span> {{minutes | two_digits}} </span> : <span> {{seconds | two_digits}} </span> -->
		</template>
		<template v-else><span>Expired</span></template>
	</div>
</template>

<script>
export default {
	name: 'daycount',
	props: {
		date: {
			type: String
		}
	},
	data() {
		return {
			now: Math.trunc((new Date()).getTime() / 1000)
		}
	},
	computed: {
		dateInMilliseconds() {
			return Math.trunc(Date.parse(this.date) / 1000)
		},
		seconds() {
			if(this.date){
				return (this.dateInMilliseconds - this.now) % 60;
			}
			else{
				return 59
			}
		},
		minutes() {
			if(this.date){
				return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
			}
			else{
				return 59
			}
		},
		hours() {
			if(this.date){
				return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60);
			}
			else{
				return 23
			}
		},
		days() {
			return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
		}
	},
	mounted() {
		window.setInterval(() => {
			this.now = Math.trunc((new Date()).getTime() / 1000);
		}, 1000);
	},
}
</script>